<template>
  <div class="bought-page">
    <div class="rec-con">
      <div class="title">我买的车</div>
      <div class="list-con">
        <div class="list">
          <div class="resev-item" v-for="item in viewDataList" :key="item.uuid" @click="navigateTo(`/t12?id=${item.pageid}&psn=${item.psn}`)">
            <div class="row"><div class="value"><h2>{{item.title}}</h2></div></div>
            <div class="row"><div class="field">车型</div><div class="value">{{item.model}}</div></div>
            <div class="row"><div class="field">价格</div><div class="value">{{item.price}}万</div></div>
            <div class="row"><div class="field">购买时间</div><div class="value">{{item.tradedate}}</div></div>
          </div>
        </div>
        <div class="emp-box" v-if="dataLoaded && viewDataList.length === 0">
          <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/empty-content.png" class="emp-img"/>
          <span class="emp-txt">暂无车辆信息</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { getMyCars, getProjects } from '../api' 

export default {
  components: {},
  props: {},
  data() {
    return {
      viewDataList: [],
      dataLoaded: false,
      queryParams:{
        qc_openid: "",
        qc_projectid: "",
        page: 1,
        rows: 10
      }
    };
  },
  watch: {
    userInfo(newInfo){
      const { user: { openid, appid}} = newInfo
      this.queryParams.qc_openid = openid
      getProjects({appid}).then(resp => {
        if(resp.code === 0){
          const soldProject = resp.data.find(item => item.type === 2)
          if(soldProject){
            this.queryParams.qc_projectid = soldProject.projectid
            this.loadMyBoughtCars().then(res => {})
          }
        }
      })
    }
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "userInfo"
    ])
  },
  methods: {
    async loadMyBoughtCars(){
      const { queryParams } = this
      const ret = await getMyCars(queryParams)
      if(ret.code === 0){
        this.viewDataList = ret.data.records
        this.dataLoaded = true
      }
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.bought-page{
  width: 100%;
    .title{
        font-size: 0.3243462396107845rem;
        color:#313131;
        padding: 0.5rem 0rem .1rem .3rem;
    }
    .list-con{
        width: 100%;
    }
    .list{
        display: flex;
        flex-direction: column;
        position: relative;
        border-radius: 10px;
        margin: 0.30407459963511047rem 0.30407459963511047rem 0px 0.30407459963511047rem;
        .resev-item{
            background:#fff;
            box-shadow: 0px 0.040543279951348064rem 0.15203729981755523rem 0px rgba(0, 0, 0, 0.06);
            border-radius: 5px;
            padding: 0px 0.30407459963511047rem;
            margin-bottom: 0.30407459963511047rem;
            .row{
                display: flex;
                align-items: center;
                border-bottom: solid 1px #f1f1f1;
                padding: 0.2533954996959254rem 0px;
                .field{
                    width: 1.3176565984188122rem;
                    color:#888888;
                    font-size: 0.2635313196837624rem;
                }
                .value{
                    flex: 1;
                    color:#555555;
                    font-size: 0.2635313196837624rem;
                }
            }
        }
        .status-tag{
            width: 1.0135819987837016rem;
            height: 1.0135819987837016rem;
            position: absolute;
            right: 0.20271639975674033rem;
            top: 0.20271639975674033rem;
        }
    }
  
}
.emp-box{
  display:flex;
  flex-direction:column;
  align-items: center;
  .emp-img{
    max-width: 5.6rem;
  }
  .emp-txt{
    padding: .2rem;
    font-size: .3rem;
    color:#999;
  }
}
</style>